var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class DWOJobService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "dwo_job";
    }
    approveDWO(dwoJobId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}/${dwoJobId}/approve`);
            return data;
        });
    }
}
export const dwoJobService = new DWOJobService();
//# sourceMappingURL=dwoJobService.js.map